var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-3 mx-n3",
    attrs: {
      "max-width": "1280",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "이용약관 목록"
    }
  }), _c('v-data-table', {
    staticClass: "v-sheet--outlined",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.policies,
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.createdAt",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(item.createdAt.toDate()) + " ")];
      }
    }, {
      key: "item.terms",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-responsive', [_c('v-row', {
          on: {
            "click": function click($event) {
              return _vm.$set(item, 'show', !item.show);
            }
          }
        }, [_c('v-col', {
          staticClass: "text-start"
        }, [_vm._v(_vm._s(item.subject))]), _c('v-spacer'), _c('v-col', {
          attrs: {
            "cols": "auto"
          }
        }, [!item.show ? _c('v-icon', [_vm._v("mdi-chevron-down")]) : _c('v-icon', [_vm._v("mdi-chevron-up")])], 1)], 1), _c('v-expand-transition', [_c('v-row', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: item.show,
            expression: "item.show"
          }],
          staticClass: "mx-0"
        }, [_c('p', {
          domProps: {
            "innerHTML": _vm._s(item.content)
          }
        })])], 1)], 1)];
      }
    }, {
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-icon', {
          staticClass: "mr-2",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.edit(item);
            }
          }
        }, [_vm._v(" mdi-pencil ")]), _c('v-icon', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(item);
            }
          }
        }, [_vm._v(" mdi-delete ")])];
      }
    }], null, true)
  }), _c('v-pagination', {
    staticClass: "mt-4 mb-12",
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  }), _c('v-dialog', {
    attrs: {
      "max-width": "800px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "bottom": "",
            "color": "accent",
            "dark": "",
            "fab": "",
            "fixed": "",
            "right": ""
          },
          on: {
            "click": _vm.create
          }
        }, on), [_c('v-icon', [_vm._v("mdi-pencil")])], 1)];
      }
    }]),
    model: {
      value: _vm.dialog,
      callback: function callback($$v) {
        _vm.dialog = $$v;
      },
      expression: "dialog"
    }
  }, [_vm.dialog && _vm.editItem ? _c('v-card', [_vm.editItem._id ? _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("약관 수정")]) : _c('v-card-title', {
    staticClass: "subtitle-1"
  }, [_vm._v("약관 등록")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "약관코드",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.code,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "code", $$v);
      },
      expression: "editItem.code"
    }
  }), _c('v-text-field', {
    staticClass: "mt-4",
    attrs: {
      "label": "제목",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "subject", $$v);
      },
      expression: "editItem.subject"
    }
  }), _c('naver-smarteditor', {
    staticClass: "mt-2",
    model: {
      value: _vm.editItem.content,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "content", $$v);
      },
      expression: "editItem.content"
    }
  }), _c('v-row', {
    staticClass: "mt-4",
    attrs: {
      "justify": "center",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "py-0 subtitle-1",
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("필수여부")]), _c('v-spacer'), _c('v-col', {
    staticClass: "py-0",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-switch', {
    staticClass: "mt-0 pa-0",
    attrs: {
      "hide-details": ""
    },
    model: {
      value: _vm.editItem.necessary,
      callback: function callback($$v) {
        _vm.$set(_vm.editItem, "necessary", $$v);
      },
      expression: "editItem.necessary"
    }
  })], 1)], 1)], 1), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "text": ""
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }